import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from "react-router-dom";

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import { getBranch } from '../../routes/UserAction';
import { domain, reduceText, timeFormat } from '../../data/dummyData';

import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Carousel.css";

export default function Branch() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);

    const search = useLocation().search;
    const id = new URLSearchParams(search).get("id");

    const [pageData, setPageData] = useState(null);

    useEffect(() => {
        dispatch(getBranch(id))
            .then(response => {
                setPageData(response.payload.data);
            })
            .catch(console.error);
    }, [id]);

    const options3 = {
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        // items: 3,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        }
    };

    return (
        <>
            <Header page={'country'} />

            {/* <!-- About Start --> */}
            <div className="container-fluid about pt-5" style={{zIndex: 1}}>
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                            <div className="about-content h-100">
                                <h4 className="" style={{color: 'gold'}}>{pageData?.name? pageData.name: ''}({pageData?.name? pageData.name: ''})</h4>
                                {/* <h1 className="display-4 text-white mb-4">{pageData?.about? pageData.about: ''}</h1> */}
                                <hr/>
                                <p className="mb-4 text-white">{pageData?.about? pageData.about: ''}</p>
                                
                                
                            </div>
                        </div>
                        <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="about-img h-100">
                                <div className="about-img-inner d-flex h-100">
                                    <img src={pageData?.image? domain+pageData.image: "./assets/img/emy.png"} className="img-fluid w-100" style={{objectFit: 'contain'}} alt={pageData?.uuid? pageData.uuid :''}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}

            {/* <!-- Team Start --> */}
            <div className="container-fluid blog py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        {/* <h4 className="text-primary">  Our Blogs</h4> */}
                        <h4 className="" style={{color: 'gold'}}> {pageData?.name? pageData?.name : ''} Team </h4>
                        <h1 className="display-4 mb-4">Team Members</h1>
                    </div>

                    <OwlCarousel
                        className="blog-carousel owl-carousel"
                        {...options3}
                    >
                    {/* <div className="blog-carousel owl-carousel"> */}
                    {Array.isArray(pageData?.groups) &&
                        pageData.groups.length > 0 &&
                        pageData.groups[0].members?.length ? (
                        pageData.groups[0].members.map((row, index) => (
                            <div key={index} className="blog-item wow fadeInUp" data-wow-delay="0.2s">
                            <div className="blog-img p-4 pb-0">
                                <a href="#">
                                <img
                                    src={row.image ? domain + row.image : "./assets/img/soft.png"}
                                    className="img-fluid w-100"
                                    alt=""
                                />
                                </a>
                            </div>
                            <div className="blog-content p-4">
                                <div className="blog-comment d-flex justify-content-center py-2 px-3 mb-4">
                                <div className="small text-primary">
                                    <span className="fa fa-calendar text-primary me-2"></span>
                                    {row?.msg || ''}
                                </div>
                                </div>
                                <a href="#" className="h4 d-inline-block mb-3">{row?.name || ''}</a>
                                <p className="mb-3">{row?.about ? reduceText(row.about, 200, '...') : ''}</p>
                                <Link to={row.uuid ? `/chat?id=${row.uuid}&&cat=member` : '/'} className="btn btn-dark py-2 px-4 ms-2">
                                <span className="me-2">Contact</span>
                                <i className="fa fa-arrow-right"></i>
                                </Link>
                            </div>
                            </div>
                        ))
                        ) : null}
                        
                    {/* </div> */}
                    </OwlCarousel>
                </div>
            </div>
            {/* <!-- Team End --> */}

            {/* map */}
            <div className="col-12 wow fadeInUp" data-wow-delay="0.2s">
                <div className="h-100 overflow-hidden">
                    <iframe className="w-100" style={{height: '400px'}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd" 
                    loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
            {/* Map End */}

            <Footer />
        </>
    );
}
